var storage = {
    save: function(name, form) {
        if (typeof(Storage) !== 'undefined') {
            localStorage.setItem(name, JSON.stringify(form));
        }
    },
    get: function(name) {
        if (typeof(Storage) !== 'undefined') {
            try {
                var data = localStorage.getItem(name);
                return JSON.parse(data);
            } catch (err) {
                return '';
            }
        }
    },
    delete: function(name) {
        if (typeof(Storage) !== 'undefined') {
            try {
                localStorage.removeItem(name);
            } catch (err) {
                return '';
            }
        }
    }
};